import { StackActions } from "@react-navigation/native";
import * as React from "react";
export const navigationRef = React.createRef();
export const AppContainerRef = React.createRef();

export function navigate(name, params) {
  navigationRef.current?.navigate(name, params);
}

export function popToPop() {
  navigationRef.current?.dispatch(StackActions.popToTop());
}

export function goBack() {
  navigationRef.current?.goBack();
}

export function routeName() {
  navigationRef?.current?.getCurrentRoute()?.name;
}

export function addListener(function1, function2, function3) {
  navigationRef.current?.addListener("focus", () => {
    function1;
    function2;
    function3;
  });
}

export function navigation() {
  navigationRef;
}

export function GetRef() {
  AppContainerRef.current;
}
